'use client';

import Image from 'next/image';

import { IResolvedCardComplex } from '@/src/utils/collections/cards.mapper';

export const CardComplex = ({
  topLeftText,
  topRightText,
  image,
  infoCardItems,
  bottomText,
}: IResolvedCardComplex) => {
  return (
    <div
      className={
        'max-w-1200 flex-col items-center gap-4 py-8 lg:mx-auto lg:py-0'
      }
    >
      <div className={'flex flex-col md:flex-row'}>
        <div
          className={
            'flex-1 rounded-2xl bg-white px-8 md:-mb-10 md:ml-10 md:mt-10 md:py-12 md:shadow-2xl [&_h1]:text-3xl [&_h1]:font-bold [&_h2]:text-3xl [&_h2]:font-bold [&_h3]:text-3xl [&_h3]:font-bold [&_h4]:text-3xl [&_h4]:font-bold [&_h5]:text-3xl [&_h5]:font-bold [&_h6]:text-3xl [&_h6]:font-bold [&_p]:mb-3'
          }
        >
          {topLeftText}
        </div>
        <div
          className={'flex flex-1 items-end p-8 align-bottom text-neutral-700'}
        >
          {topRightText}
        </div>
      </div>
      <div className={'relative mx-8 h-[560px] max-w-1200'}>
        <Image
          src={image?.image || ''}
          alt={image?.alt || ''}
          placeholder={'blur'}
          blurDataURL={'/static/images/placeholder.webp'}
          className={'-z-10 rounded-4xl'}
          layout="fill"
          objectFit="cover"
          objectPosition="center"
          loading={'lazy'}
        />
        <div
          className={
            'absolute bottom-0 right-0 flex flex-col gap-16 rounded-3xl bg-yellow p-8 md:flex-row'
          }
        >
          {infoCardItems.map((item, index) => (
            <div className={'flex flex-col'} key={`card_complex_${index}`}>
              <div className={'text-5xl font-bold'}>{item.title}</div>
              <div>{item.text}</div>
            </div>
          ))}
        </div>
      </div>
      <div
        className={
          'mx-8 mt-8 max-w-[580px] md:mx-auto [&_*]:mb-3 [&_h1]:text-2xl [&_h1]:font-bold [&_h2]:text-2xl [&_h2]:font-bold [&_h3]:text-2xl [&_h3]:font-bold [&_h4]:text-2xl [&_h4]:font-bold [&_h5]:text-2xl [&_h5]:font-bold [&_h6]:text-2xl [&_h6]:font-bold'
        }
      >
        {bottomText}
      </div>
    </div>
  );
};
